import { Bounce, toast } from "react-toastify";

const errorNotify = (text: string) => toast.error(text, {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  transition: Bounce,
});

export default errorNotify;